import * as React from 'react';
import { CommonServiceContainer } from '../CommonService';
import { SubscriptionServiceContainer } from '../SubscriptionService';
import { IServiceOwnProps } from './types';

export const Service = (props: IServiceOwnProps) => {
  const { serviceId } = props;

  switch (serviceId) {
    case 'servicePackage':
      return <SubscriptionServiceContainer />;

    default:
      return <CommonServiceContainer serviceId={serviceId} />;
  }
};
